import React from "react";
import Icon from "./Icon";
import "./InternalIndicator.css";

const InternalIndicator = function InternalIndicator() {
    return (
        <div className="internal-indicator">
            <Icon.VpnKey.Small.N60.Fill />
        </div>
    );
};

export default InternalIndicator;
